import { ScheduleOffsetUnit } from "@simplyk/common";

export const AUTOMATED_EMAIL_OPENED_CARD_VALUES = [
  "thank-you-email",
  "thank-you-email-fundraiser",
  "thank-you-bid-placed",
  "thank-you-non-winner",
  "outbid",
  "reminder-1",
  "reminder-2",
  "expiring-membership",
  "auto-renewal",
  "ready-for-pickup",
  "order-shipped",
] as const;

export type AutomatedEmailOpenedCard = (typeof AUTOMATED_EMAIL_OPENED_CARD_VALUES)[number];

export const DEFAULT_AUTOMATED_EMAIL_OPENED_CARD: AutomatedEmailOpenedCard = "thank-you-email";

export const TICKETING_EDIT_STEP_HASH = "automated-communications";

export const DONATION_EDIT_STEP_HASH = "thank-you-email";

type EmailAttachment = { fileUrl: string | null; filename: string | null };

export interface AutomatedCommunicationsFormData {
  thankYouWinner: { subject: string; content: string; attachment?: EmailAttachment };
  thankYouBidPlaced: { subject: string; content: string };
  thankYouNonWinner: { subject: string; content: string };
  outbid: { smsEnabled: boolean };
  reminder1: ReminderFormData;
  reminder2: ReminderFormData;
  expiringMembership: RenewalFormData;
  autoRenewal: RenewalFormData;
  readyForPickup: FulfillmentFormData;
  orderShipped: FulfillmentFormData;
}

export interface FulfillmentFormData {
  enabled: boolean;
  subject: string;
  content: string;
}

export interface ReminderFormData {
  enabled: boolean;
  emailEnabled: boolean;
  smsEnabled: boolean;
  subject: string;
  content: string;
  attachment?: EmailAttachment;
  offset: number;
  offsetUnit: ScheduleOffsetUnit;
}

export interface RenewalFormData {
  enabled: boolean;
  delayDays: number;
  subject: string;
  content: string;
}

export type RowKey = AutomatedEmailOpenedCard;
